// capture/getDirection.js
import { POSE_RULES, POSE_TARGETS } from "./overlayConfig";

export function getDirection(pose, stage, poseNumber) {
  if (!pose || pose.pitch === undefined || pose.yaw === undefined) return null;
  const { pitch, yaw } = pose;

  if (stage === "Present_Neutral") {
    if (pitch < -15) return "UP";     // head tilted down → look up
    if (pitch >  15) return "DOWN";   // head tilted up → look down
    if (yaw   >  15) return "RIGHT";  // turned left of center → turn right
    if (yaw   < -15) return "LEFT";   // turned right of center → turn left
    return null;
  }

  // Pose variations
  const stageRules = POSE_RULES[stage];
  const rule = stageRules ? stageRules[poseNumber] : null;
  const targetTuple = POSE_TARGETS[poseNumber];

  if (!rule && targetTuple) {
    const [wantPitch, wantYaw] = targetTuple;
    const dPitch = wantPitch - pitch;
    const dYaw = wantYaw - yaw;
    if (Math.abs(dPitch) > 10 && Math.abs(dPitch) > Math.abs(dYaw)) {
      return dPitch > 0 ? "UP" : "DOWN";
    }
    if (Math.abs(dYaw) > 10) {
      return dYaw > 0 ? "LEFT" : "RIGHT";
    }
    return null;
  }

  if (rule) {
    const needPitchUp = pitch < rule.pMin;
    const needPitchDown = pitch > rule.pMax;
    const needYawLeft = yaw < rule.yMin;
    const needYawRight = yaw > rule.yMax;

    if (needPitchUp && needYawLeft) return "UP-LEFT";
    if (needPitchUp && needYawRight) return "UP-RIGHT";
    if (needPitchDown && needYawLeft) return "DOWN-LEFT";
    if (needPitchDown && needYawRight) return "DOWN-RIGHT";

    if (needPitchUp) return "UP";
    if (needPitchDown) return "DOWN";
    if (needYawLeft) return "LEFT";
    if (needYawRight) return "RIGHT";
  }

  return null;
}
